/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_TitleInputs */

const en_cp_cmp_title = /** @type {(inputs: Cp_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is this different from Bangkit, P2MW, GDGoC, 1000 Startup?`)
};

const id_cp_cmp_title = /** @type {(inputs: Cp_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedanya dengan Bangkit, P2MW, GDGoC, 1000 Startup?`)
};

/**
* | output |
* | --- |
* | "How is this different from Bangkit, P2MW, GDGoC, 1000 Startup?" |
*
* @param {Cp_Cmp_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_title = /** @type {((inputs?: Cp_Cmp_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_title(inputs)
	return en_cp_cmp_title(inputs)
});